import ApiGServer from "services/ApiGServer";
import ApiMServer from "services/ApiMServer";

// Serviço centralizado para administração de branches e atualizações

export const getBranches = async (limit = null) => {
  try {
    const endpoint = limit ? `/branches/recent?limit=${limit}` : "/branches";
    const { data } = await ApiMServer.get(endpoint);
    return data;
  } catch (error) {
    console.error("Erro ao buscar branches:", error.message);
    return [];
  }
};

export const getAllBranches = async () => {
  try {
    const { data } = await ApiMServer.get("/api/v1/check-branches");
    return data;
  } catch (error) {
    console.error("Erro ao buscar branches:", error.message);
    return [];
  }
};

export const getEquipmentDetails = async () => {
  try {
    const { data } = await ApiGServer.get("/equipment/all/filtered");
    // Mapear os dados da API para o formato esperado pelo componente
    const mappedData = Array.isArray(data) ? data.map(equipment => ({
      id: equipment.serialnumber || equipment._id,
      name: `${equipment.serialnumber || 'Sem Serial'}`,
      location: equipment.address?.formatedAddr ||
        `${equipment.address?.city?.longname}, ${equipment.address?.state?.shortname}` ||
        'Localização não informada',
      currentVersion: equipment.versaosw || 'Versão não informada',
      status: equipment.updatedAt ?
        (new Date() - new Date(equipment.updatedAt) < 24 * 60 * 60 * 1000 ? 'online' : 'offline') :
        'offline',
      // Dados adicionais que podem ser úteis
      firmwarePri: equipment.versaofwpri,
      firmwareOsc: equipment.versaofwosc,
      lastUpdate: equipment.updatedAt,
      mode: equipment.mode,
      coordinates: {
        lat: equipment.lat,
        lng: equipment.lng
      },
      city: equipment.address?.city?.longname,
      state: equipment.address?.state?.shortname
    })) : [];

    return mappedData;
  } catch (error) {
    console.error("Erro ao buscar equipamentos:", error.message);
    return [];
  }
};

// Função para agrupar equipamentos por região
export const getEquipmentsByRegion = async () => {
  try {
    const equipments = await getEquipmentDetails();

    // Filtrar apenas equipamentos SIMT
    const filteredEquipments = equipments.filter(equipment => {
      const isSIMTEquipment = equipment.id &&
        equipment.id.startsWith('SIMT-');

      return isSIMTEquipment;
    });

    // Agrupar equipamentos filtrados por estado e cidade
    const regionGroups = filteredEquipments.reduce((acc, equipment) => {
      const state = equipment.state || 'Não informado';
      const city = equipment.city || 'Não informado';
      const regionKey = `${state}`;
      const cityKey = `${state} - ${city}`;

      // Agrupar por estado
      if (!acc.states[regionKey]) {
        acc.states[regionKey] = {
          name: state,
          equipments: [],
          cities: {}
        };
      }
      acc.states[regionKey].equipments.push(equipment);

      // Agrupar por cidade dentro do estado
      if (!acc.states[regionKey].cities[city]) {
        acc.states[regionKey].cities[city] = {
          name: city,
          equipments: []
        };
      }
      acc.states[regionKey].cities[city].equipments.push(equipment);

      // Agrupar por cidade global
      if (!acc.cities[cityKey]) {
        acc.cities[cityKey] = {
          name: cityKey,
          state: state,
          city: city,
          equipments: []
        };
      }
      acc.cities[cityKey].equipments.push(equipment);

      return acc;
    }, { states: {}, cities: {} });

    return regionGroups;
  } catch (error) {
    console.error("Erro ao agrupar equipamentos por região:", error.message);
    return { states: {}, cities: {} };
  }
};

export const getUpdates = async (order = "desc") => {
  try {
    const { data } = await ApiMServer.get("/api/v1/updates", {
      params: { order }
    });
    return data;
  } catch (error) {
    console.error("Erro ao buscar histórico de liberações:", error.message);
    throw error;
  }
};

export const sendUpdateSelection = async (payload) => {
  try {
    const { data } = await ApiMServer.post("/api/v1/updates", payload);
    return data;
  } catch (error) {
    console.error("Erro ao salvar liberação de atualização:", error.message);
    throw error;
  }
};

export const getUpdatesRelease = async (order = "desc") => {
  try {
    const { data } = await ApiMServer.get("/updates-release/v1/updates-release", {
      params: { order }
    });
    return data;
  } catch (error) {
    console.error("Erro ao buscar histórico de liberações (release):", error.message);
    throw error;
  }
};

export const sendUpdateReleaseSelection = async (payload) => {
  try {
    const { data } = await ApiMServer.post("/updates-release/v1/updates-release", payload);
    return data;
  } catch (error) {
    console.error("Erro ao salvar liberação de atualização (release):", error.message);
    throw error;
  }
};

export const listUpdateHistory = async (order = "desc") => getUpdates(order);

export const createUpdateHistory = async (payload) => sendUpdateSelection(payload);

export const updateBranches = async () => {
  try {
    const { data } = await ApiMServer.post("/api/v1/update-branches");
    return data;
  } catch (error) {
    console.error("Erro ao atualizar as branches:", error.message);
    throw error;
  }
};

export default {
  getBranches,
  getAllBranches,
  getEquipmentDetails,
  getEquipmentsByRegion,
  getUpdates,
  getUpdatesRelease,
  listUpdateHistory,
  sendUpdateSelection,
  sendUpdateReleaseSelection,
  createUpdateHistory,
  updateBranches,
};
